import React from 'react'
import { useState } from "react";
import "../auth/css/forgotPassword.css";
import SolarSquare from "../../assets/img/logo.svg";
import Check from "../../assets/img/check.svg";

import ApiUrl from "../../common/apiUrl";


const ResetCredentials = () => {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [isSuccessSent, setIsSuccessSent] = useState(false)



    async function handleSubmit(e) {
        e.preventDefault();
        setSubmitted(true);
        const myHeaders = new Headers();
        myHeaders.append("X-Tenant-Id", process.env.REACT_APP_X_TENANT_ID);
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            "email": email
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };


        fetch(ApiUrl.RESET_CREDENTIALS_ENDPOINT_UPDATE, requestOptions)
            .then((response) =>
                response.text()
            ).then((result) => {
                result = JSON.parse(result);
                console.log("result", result);
                if (result && result.status === false) {
                    setError(result.message);
                    setSubmitted(false);
                    setIsSuccessSent(false);
                    return;
                }
                

                if (result && result.status === true) {
                    setError('');
                    // alert("Password reset link sent to your email");
                    setSubmitted(false);
                    setIsSuccessSent(true);
                } 
            }).catch((error) => {
                console.error("Error in updatePassword", error);
                setError('Error in sending mail. Please try again later');
                setSubmitted(false);
                setIsSuccessSent(false);
            })


    }

    function handleChange(e) {
        setError('');
        setEmail(e.target.value);
        setSubmitted(false);
    }
    return (
        <div className="login-container">

            <div className="login-card reset-cred" style={{
                borderBottomLeftRadius: isSuccessSent ? "8px" : "0px",
                borderBottomRightRadius: isSuccessSent ? "8px" : "0px",
            }}>

                <div className="logo-container">
                    <div className="logo">
                        <img src={SolarSquare} alt="solar-sqaure" className="img-logo" />
                    </div>
                </div>

                {
                    isSuccessSent ? (
                        <div className="card">
                            <img src={Check} alt='Check-icon' style={{
                                height:"20px",
                                width:"20px",
                            }}/>
                            <div className="card-content">{"You should receive an email shortly with further instructions."}</div>
                        </div>
                    ) : (
                        <>
                            <h2 className="login-title">Forgot Password?</h2>
                            <p className="login-subtitle">Please enter your register Email ID to reset your password</p>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email ID"
                                        value={email}
                                        onChange={handleChange}
                                        className="input-field"
                                        required
                                    />
                                {error && <p className="error-message" style={{ color: 'red', textAlign: 'left', margin:'1px', marginTop:'5px' }}>{error}</p>}
                                </div>

                                <div className="form-group">
                                    <button type="submit" className="submit-button" disabled={submitted}>
                                        {
                                            submitted ? "Please wait..." : "Submit"
                                        }
                                    </button>
                                </div>
                            </form>
                        </>

                    )
                }



            </div>
            {
                !isSuccessSent && (
                    <div style={{
                        fontSize: "13px",
                        padding: "15px 35px",
                        backgroundColor: "#F0F0F0",
                        borderBottomLeftRadius: "8px",
                        borderBottomRightRadius: "8px",
                        textAlign: "center",
                        maxWidth: "420px"
                    }}
                    className='reset-cred-footer'
                    >
                        Enter your email address and we will send you instructions on how to create a new password.
        
                    </div>
                )
            }

        </div >
    )
}

export default ResetCredentials